import { Typography as CssModulesTypography, TypographyVariant } from '@sunwebgroup/uds-ui/typography'
import * as React from 'react'
import { css, type RuleSet, styled } from 'styled-components'
import { SemanticsTextColorUdsToken, textColor, withStyleModifiers } from '../../../utils'
import { VARIANT_TO_CSS } from '../../modifier-styles/generated/typography'

export interface TypographyWrapperProps extends React.HTMLAttributes<HTMLSpanElement> {
  as?: React.ElementType
  className?: string | undefined
  variant?: TypographyVariant
  /**
   * @deprecated Avoid using this prop. Prefer assigning the color via
   * CSS modules using classes or through styles cascade.
   * In case of need using styled-components, create styled wrapper
   * around the Typography component or set the color through the parent.
   */
  $color?: SemanticsTextColorUdsToken
}

function TypographyWrapper({ variant, className, as, ...props }: React.PropsWithChildren<TypographyWrapperProps>) {
  return (
    <CssModulesTypography
      as={as}
      variant={variant}
      className={className}
      {...props}
    />
  )
}

function modVariant(variant: TypographyVariant) {
  const cssString = VARIANT_TO_CSS[variant]
  return css`${cssString ?? ''}`
}

function modColor(colorName: SemanticsTextColorUdsToken): RuleSet<object> {
  return css`
    color: ${textColor(colorName)};
  `
}

export const StyledTypographyWithModifiers = withStyleModifiers(
  styled(TypographyWrapper)``,
  { modVariant, modColor },
)
